"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocxExporter = void 0;
var data_1 = require("./data");
var core_properties_1 = require("./exporters/core-properties");
var numberings_1 = require("./exporters/numberings");
var core_relations_1 = require("./exporters/relations/core-relations");
var settings_1 = require("./exporters/settings");
var styles_1 = require("./exporters/styles");
var header_footer_sub_document_exporter_1 = require("./exporters/sub-document/header-footer-sub-document-exporter");
var main_sub_document_1 = require("./exporters/sub-document/main-sub-document");
var theme_1 = require("./exporters/theme");
var DocxExporter = (function () {
    function DocxExporter(modelManipulator, options) {
        this.modelManipulator = modelManipulator;
        this.options = options;
        this.data = new data_1.Data(modelManipulator.model, options);
    }
    DocxExporter.prototype.exportToBlob = function (callback) {
        var _this = this;
        this.modelManipulator.picture.loader.ensureAllPicturesLoaded(this.options.ensurePictureLoadedTimeout, function (_loaded) {
            _this.exportInner();
            _this.data.zipBuilder.generateBlob(callback);
        });
    };
    DocxExporter.prototype.exportToBase64 = function (callback) {
        var _this = this;
        this.modelManipulator.picture.loader.ensureAllPicturesLoaded(this.options.ensurePictureLoadedTimeout, function (_loaded) {
            _this.exportInner();
            _this.data.zipBuilder.generateBase64(callback);
        });
    };
    DocxExporter.prototype.exportInner = function () {
        new core_properties_1.CorePropertiesExporter(this.data).export();
        this.exportCustomProperties();
        new main_sub_document_1.MainSubDocumentExporter(this.data, this.data.model.mainSubDocument, 'word/document.xml').export();
        for (var subDocument = void 0; subDocument = this.data.exportSubDocumentsList.pop();) {
            var baseFileName = "" + (subDocument.isHeader() ? 'header' : 'footer') + subDocument.id + ".xml";
            new header_footer_sub_document_exporter_1.HeaderFooterSubDocumentExporter(this.data, subDocument, "word/" + baseFileName, "word/_rels/" + baseFileName + ".rels").export();
        }
        new styles_1.StylesExporter(this.data).export();
        new numberings_1.NumberingsExporter(this.data).export();
        new settings_1.SettingsExporter(this.data).export();
        this.exportFootNotesAndEndNotes();
        this.exportComments();
        this.exportWebSettings();
        new theme_1.ThemeExporter(this.data).export();
        new core_relations_1.CoreRelationsExporter(this.data).export();
        this.data.popRelationExporter();
        this.data.contentTypesExporter.export();
    };
    DocxExporter.prototype.exportCustomProperties = function () {
    };
    DocxExporter.prototype.exportFootNotesAndEndNotes = function () {
    };
    DocxExporter.prototype.exportComments = function () {
    };
    DocxExporter.prototype.exportWebSettings = function () {
    };
    return DocxExporter;
}());
exports.DocxExporter = DocxExporter;
